import React from 'react';

import HandsRaisedIcon from '../assets/hands_raised.svg';
import MapIcon from '../assets/map.svg';

const infoSections = [
  {
    icon: <img src={HandsRaisedIcon} alt="Hands raised in the air" />,
    name: 'Improve your MCAT score, guaranteed!',
    text: 'Magoosh has high quality MCAT questions, full-length practice tests, expert content review videos, custom study schedules and more.'
  },
  {
    icon: <img src={MapIcon} alt="Map showing a path to follow" />,
    name: 'Plus! 24/7 Email Support',
    text: 'Quick email and chat support from our test prep experts when you get stuck or just want some extra help.'
  }
];

export default { infoSections };
